// ═══════════════════════════════════════
// FULLSCREEN — Mode plein écran partition
// Affiche .partition-view en plein écran avec auto-hide de #audio-container
// ═══════════════════════════════════════

const HIDE_DELAY = 3000; // ms avant que la barre se cache

let _hideTimer   = null;
let _isFs        = false;

// ── Éléments ──────────────────────────────
function els() {
    return {
        btn:       document.getElementById('fullscreen-btn'),
        iconEnter: document.getElementById('fs-icon-enter'),
        iconExit:  document.getElementById('fs-icon-exit'),
        view:      document.querySelector('.partition-view'),
        bar:       document.getElementById('audio-container'),
        notation:  document.querySelector('.partition-view-inner'),
    };
}

// ── Afficher/masquer la barre ─────────────
function showBar() {
    const { bar } = els();
    if (!bar) return;
    bar.classList.remove('fs-bar--hidden');
    scheduleHide();
}

function hideBar() {
    const { bar } = els();
    if (!bar) return;
    bar.classList.add('fs-bar--hidden');
}

function scheduleHide() {
    clearTimeout(_hideTimer);
    _hideTimer = setTimeout(hideBar, HIDE_DELAY);
}

function cancelHide() {
    clearTimeout(_hideTimer);
}

// ── Entrée / sortie plein écran ───────────
function enterFullscreen() {
    const { view, bar, iconEnter, iconExit, notation } = els();
    if (!view) return;

    view.classList.add('fs-active');
    iconEnter.style.display = 'none';
    iconExit.style.display  = '';
    _isFs = true;

    // Première apparition de la barre, puis auto-hide
    showBar();

    // Clic sur la zone partition → réaffiche la barre
    notation?.addEventListener('pointerdown', _onNotationClick);

    // Barre : garder visible tant que la souris est dessus
    bar?.addEventListener('pointerenter', _onBarEnter);
    bar?.addEventListener('pointerleave', _onBarLeave);

    // Touche Échap → sortie
    document.addEventListener('keydown', _onKeyDown);

    // Synchronise avec l'API Fullscreen du navigateur si dispo
    if (view.requestFullscreen) {
        view.requestFullscreen().catch(() => {/* silencieux */});
    }
}

function exitFullscreen() {
    const { view, bar, iconEnter, iconExit, notation } = els();
    if (!view) return;

    view.classList.remove('fs-active');
    iconEnter.style.display = '';
    iconExit.style.display  = 'none';
    _isFs = false;

    cancelHide();
    bar?.classList.remove('fs-bar--hidden');

    notation?.removeEventListener('pointerdown', _onNotationClick);
    bar?.removeEventListener('pointerenter', _onBarEnter);
    bar?.removeEventListener('pointerleave', _onBarLeave);
    document.removeEventListener('keydown', _onKeyDown);

    if (document.fullscreenElement) {
        document.exitFullscreen().catch(() => {});
    }
}

// ── Handlers ─────────────────────────────
function _onNotationClick() {
    showBar();
}

function _onBarEnter() {
    cancelHide();
    const { bar } = els();
    bar?.classList.remove('fs-bar--hidden');
}

function _onBarLeave() {
    scheduleHide();
}

function _onKeyDown(e) {
    if (e.key === 'Escape') {
        exitFullscreen();
    }
}

// ── API publique ──────────────────────────
export function toggleFullscreen() {
    _isFs ? exitFullscreen() : enterFullscreen();
}

export function initFullscreen() {
    const { btn } = els();
    if (!btn) return;

    btn.addEventListener('click', toggleFullscreen);

    // Synchro si l'utilisateur sort via F11 ou geste natif
    document.addEventListener('fullscreenchange', () => {
        if (!document.fullscreenElement && _isFs) {
            exitFullscreen();
        }
    });
}